exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".format[data-v-7b68b29e],.icon[data-v-7b68b29e],.root-icon[data-v-7b68b29e]{display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;justify-content:center;color:#fff}.icon[data-v-7b68b29e],.root-icon[data-v-7b68b29e]{width:32px;height:32px;border-radius:16px;color:inherit;-ms-flex-align:center;align-items:center}.format[data-v-7b68b29e]{height:25px;border-radius:2px;padding:2px 4px}.format span[data-v-7b68b29e]{line-height:21px;display:block;margin:auto;padding:0}.avatar[data-v-7b68b29e]{border-radius:50%;height:32px;width:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7b68b29e","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/common/files/FormatBadge.vue
// module id = 1081
// module chunks = 22